import { Controller } from "stimulus"
import validateCpfCnpj from '../helpers/validateCpfCnpj'

export default class extends Controller {
  static targets = ["cpfCnpjInput", "submitEstablishmentButton", "cpfCnpjContainer"]

  checkCpfCnpj() {
    if (this.cpfCnpjInputTarget.value.length > 0 && this.cpfCnpjInputTarget.value.length !== 14 & this.cpfCnpjInputTarget.value.length !== 18) {
      this.cpfCnpjContainerTarget.classList.add("field_with_errors")
      this.submitEstablishmentButtonTarget.disabled = true
      return
    }

    if (!validateCpfCnpj(this.cpfCnpjInputTarget.value)) {
      this.cpfCnpjContainerTarget.classList.add("field_with_errors")
      this.submitEstablishmentButtonTarget.disabled = true
      return
    }

    this.cpfCnpjContainerTarget.classList.remove("field_with_errors")
    this.submitEstablishmentButtonTarget.disabled = false
  }
}
